@if (subscription(); as sub) {
  <div class="notification-subscription">
    <mat-icon
      class="icon material-icons-outlined"
      [class.active]="sub.notificationsPreferences.smsEnabled"
      [matTooltip]="'SMS notifications: ' + (sub.notificationsPreferences.smsEnabled ? 'On' : 'Off')"
    >mark_chat_read</mat-icon>
    <mat-icon
      class="icon email-icon material-icons-outlined"
      [class.active]="sub.notificationsPreferences.emailEnabled"
      [matTooltip]="'Email notifications: ' + (sub.notificationsPreferences.emailEnabled ? 'On' : 'Off')"
    >mark_email_read</mat-icon>
  </div>
}
